import React from "react";
import { makeStyles } from "@material-ui/core";

const customStyles = makeStyles({
  root: {
    padding: "150px 0px",
    borderRadius: "24px",
    boxShadow: "0 0 40px rgba(0, 0, 0, 0.05)", // soft black glow
    margin:"0px 0px"


  },
  aboutWrapper: {
    width: "90%",
    maxWidth: "1216px",
    display: "flex",
    marginRight: "auto",
    marginLeft: "auto",
    marginTop: "-60px",
    marginBottom:"-100px"

  },
  leftSide: {
    minWidth: "58%",
    display: "flex",
    flexDirection: "column",
  },
  aboutHeader: {
    fontSize: "18px",
    fontWeight: "400",
    display: "flex",
    justifyContent: "space-between",
  },
  storeHeader: {
    marginTop: "20px",
    fontSize: "48px",
    lineHeight: "1.3em",
    fontWeight: "400",
    fontFamily: "Poppins",  

  },
  leftDetails: {
    marginTop: "40px",
    fontWeight: "200",
    fontSize: "18px",
    fontFamily:"Roboto"
  },
});


const About = () => {
  const classes = customStyles();

  return (
    <div className={classes.root}>
      <div className={classes.aboutWrapper}>
        <div className={classes.leftSide}>
          <div className={classes.aboutHeader}></div>
          <div className={classes.storeHeader}>
            <b>PickaaGO – Where Precision Meets Convenience</b>
          </div>
          <div className={classes.leftDetails}>
          India's e-commerce sector is experiencing rapid growth, valued at approximately $125 billion in 2024 and projected to reach $345 billion by 2030, driven by increasing internet penetration, smartphone adoption, and a tech-savvy population. 
          <br /><br />
          This surge in online shopping has led to a significant rise in package deliveries, bringing with it growing concerns over package theft.
          <br /><br />
          PickaaGo addresses this challenge by offering a smart, reliable delivery system tailored for today's connected lifestyles. Each parcel is authenticated using a one-time secure PIN, ensuring only authorized access. 
          <br /><br />
          The discreet unit not only safeguards your packages but also logs every transaction and updates your profile in real time, providing unmatched peace of mind. 
          <br /><br />
          In an era of booming e-commerce, your deliveries deserve more than just a doorstep, they deserve PickaaGo.
          <br /><br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;